// tslint:disable:max-line-length

import React from 'react';

export const OperatorGreaterThanOrEqual = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4.35 8.3L9.11 7 4.35 5.61V3.78l7.41 2.62v1.21l-7.41 2.52zm0 2h7.41V12H4.35z" />
    </svg>
  );
};
